// import React, { useRef, useState } from "react";
// import { Link } from "gatsby";
// import { BreadCrumbData } from "./config";
// import { Helmet } from "react-helmet";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

// const BreadCrumbComp = ({ data }) => {
//   console.log(data, "adataaaaaaaa");
//   var position = 0;
//   var breadcrumb = {
//     position: 0,
//     name: "",
//     item: "",
//   };

//   var listArray = [];

//   var items = data;
//   for (var i = 0; i < items?.length; i++) {
//     var newItem = Object.create(breadcrumb);
//     var curItem = items[i];

//     newItem["@type"] = "ListItem";
//     position++;
//     newItem.position = position;
//     newItem.name = curItem.name;
//     newItem.item = curItem.item;
//     listArray.push(newItem);
//   }

//   var breadcrumbSchema = {
//     "@context": "https://schema.org/",
//     "@type": "BreadcrumbList",
//     itemListElement: listArray,
//   };

//   let scrl = useRef(null);
//   const [scrollX, setscrollX] = useState(0);
//   const [scrolEnd, setscrolEnd] = useState(false);

//   //Slide click
//   const slide = (shift) => {
//     scrl.current.scrollLeft += shift;
//     setscrollX(scrollX + shift);

//     if (
//       Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
//       scrl.current.offsetWidth
//     ) {
//       setscrolEnd(true);
//     } else {
//       setscrolEnd(false);
//     }
//   };

//   const scrollCheck = () => {
//     setscrollX(scrl.current.scrollLeft);
//     if (
//       Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
//       scrl.current.offsetWidth
//     ) {
//       setscrolEnd(true);
//     } else {
//       setscrolEnd(false);
//     }
//   };

//   return (
//     <>
//       <Helmet htmlAttributes={{ lang: `en-US` }}>
//         <script type="application/ld+json">
//           {JSON.stringify(breadcrumbSchema)}
//         </script>
//       </Helmet>

//       <div className="w-full 2xl:px-0 py-7 shadow-2xl sm:relative absolute top-12 mt-6 sm:mt-0 sm:top-0">
//         <div className="flex max-w-7xl mx-auto items-center text-base text-[#494949] font-opensans font-semibold">
//           {scrollX !== 0 && (
//             <button
//               className="font-bold sm:hidden inline-block p-3"
//               onClick={() => slide(-50)}
//             >
//               <FontAwesomeIcon icon={faArrowLeft} className="text-orange" />
//             </button>
//           )}
//           <ul
//             ref={scrl}
//             onScroll={scrollCheck}
//             className="bread-crumb scrollbar-hide sm:flex items-center whitespace-nowrap overflow-auto"
//           >
//             {data.map((d, i, arr) => {
//               return (
//                 <li className="flex pl-3 items-center" key={i}>
//                   {i === 0 ? (
//                     <span className="flex items-center gap-x-4">
//                       <Link to={d.item}>
//                         <img
//                           src="https://tomedes.gumlet.io/S3UploadedFiles/1666089711home.svg"
//                           alt="home"
//                         />
//                       </Link>
//                     </span>
//                   ) : (
//                     <span className="flex items-center gap-x-4">
//                       <img
//                         src="https://tomedes.gumlet.io/S3UploadedFiles/1666089692greater-than.svg"
//                         alt="navigate"
//                       />
//                       {i === arr.length - 1 || !d.item ? (
//                         d.name
//                       ) : (
//                         <Link to={d.item}>
//                           <span>{d.name}</span>
//                         </Link>
//                       )}
//                     </span>
//                   )}
//                 </li>
//               );
//             })}
//           </ul>
//           {!scrolEnd && (
//             <button
//               className="text-black font-bold sm:hidden inline-block p-3"
//               onClick={() => slide(+50)}
//             >
//               <FontAwesomeIcon icon={faArrowRight} className="text-orange" />
//             </button>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default BreadCrumbComp;
import React, { useRef, useState, useEffect } from "react";
import { Link } from "gatsby";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const BreadCrumbComp = ({ data }) => {
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);

  let position = 0;
  const listArray = data.map((curItem) => ({
    "@type": "ListItem",
    position: ++position,
    name: curItem.name,
    item: curItem.item,
  }));

  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: listArray,
  };

  const scrl = useRef(null);
  const [scrollX, setScrollX] = useState(0);
  const [scrollEnd, setScrollEnd] = useState(false);

  const slide = (shift) => {
    scrl.current.scrollLeft += shift;
    setScrollX(scrollX + shift);

    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setScrollEnd(true);
    } else {
      setScrollEnd(false);
    }
  };

  const scrollCheck = () => {
    setScrollX(scrl.current.scrollLeft);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setScrollEnd(true);
    } else {
      setScrollEnd(false);
    }
  };

  return (
    <>
      <Helmet htmlAttributes={{ lang: `en-US` }}>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <div className="w-full 2xl:px-0 py-7 sm:relative absolute top-12 mt-6 sm:mt-0 sm:top-0">
        <div className="flex max-w-7xl mx-auto items-center text-base text-[#494949] font-opensans font-semibold">
          {scrollX !== 0 && (
            <button
              className="font-bold sm:hidden inline-block p-3"
              onClick={() => slide(-50)}
            >
              <FontAwesomeIcon icon={faArrowLeft} className="text-orange" />
            </button>
          )}
          <ul
            ref={scrl}
            onScroll={scrollCheck}
            className="bread-crumb scrollbar-hide sm:flex items-center whitespace-nowrap overflow-auto"
          >
            {data.map((d, i, arr) => {
              const isActive = currentPath === d.item;
              return (
                <li className="flex pl-3 items-center" key={i}>
                  {i === 0 ? (
                    <span className="flex items-center gap-x-4">
                      <Link to={d.item}>
                        <img
                          src="https://tomedes.gumlet.io/S3UploadedFiles/1666089711home.svg"
                          alt="home"
                          className="filtered-image hidden md:block"
                        />
                        <img
                          src="https://tomedes.gumlet.io/S3UploadedFiles/1666089711home.svg"
                          alt="home"
                          className="block md:hidden"
                        />
                      </Link>
                    </span>
                  ) : (
                    <span className="flex items-center gap-x-4">
                      <img
                        className="hidden md:block"
                        src="https://tomedes.gumlet.io/S3UploadedFiles/1666089692greater-than.svg"
                        alt="navigate"
                        style={{
                          filter:
                            "sepia(1) saturate(10000%) hue-rotate(180deg) brightness(0.8) opacity(0.25)",
                        }}
                      />
                      <img
                        className="block md:hidden"
                        src="https://tomedes.gumlet.io/S3UploadedFiles/1666089692greater-than.svg"
                        alt="navigate"
                      />
                      {i === arr.length - 1 || !d.item ? (
                        <span
                          className={`${
                            isActive
                              ? "font-bold text-[#494949]"
                              : "font-bold text-[#494949]"
                          } hover:font-bold hover:text-[#494949]`}
                        >
                          {d.name}
                        </span>
                      ) : (
                        <Link to={d.item}>
                          <span
                            className={`${
                              isActive
                                ? "font-normal text-[#494949]"
                                : "font-normal text-[#494949]"
                            } hover:font-normal hover:text-[#494949]`}
                          >
                            {d.name}
                          </span>
                        </Link>
                      )}
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
          {!scrollEnd && (
            <button
              className="text-black font-bold sm:hidden inline-block p-3"
              onClick={() => slide(+50)}
            >
              <FontAwesomeIcon icon={faArrowRight} className="text-orange" />
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default BreadCrumbComp;
